export const UNDER_MAINTENANCE = true

const MAINTENANCE_FEATURE_FLAG_KEY = 'maintenance-mode'

export const useUnderMaintenance = () => {
  if (typeof window !== 'undefined') {
    const maintenanceMode = window?.localStorage.getItem(MAINTENANCE_FEATURE_FLAG_KEY)
    if (maintenanceMode === 'false') return false
  }

  return UNDER_MAINTENANCE
}
